module.exports = __webpack_public_path__ + "img/solution-farmer-advantage3.40fcdc6e.svg";